import React from 'react'
import { forwardRef, HTMLAttributes, MouseEventHandler } from 'react'
import classNames from 'classnames'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
//import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'
import { IconName, IconProp, IconStyle, PullProp, SizeProp } from '@fortawesome/fontawesome-svg-core'

// documentation: https://fontawesome.com/docs/web/use-with/react/style
export interface IconProps extends HTMLAttributes<SVGSVGElement|HTMLElement> {
    name: IconName
    color?: string
    size?: SizeProp|number
    type?: IconStyle
    pull?: PullProp
    border?: boolean
    inverse?: boolean
    fixedWidth?: boolean
    className?: string
    style?: React.CSSProperties
    faProps?: Partial<FontAwesomeIconProps>
}

const Icon = forwardRef<SVGSVGElement, IconProps>(({
    name = 'icons',
    color,
    type = 'light',
    size,
    pull,
    border,
    inverse,
    fixedWidth,
    className,
    style,
    faProps,
    ...otherProps
}, ref) => {

    if (!name || typeof name !== 'string') return null

    const classes = classNames({
        'ui-icon': true
    }, className)

    const iconType = {
        regular: 'far',
        brands: 'fab',
        solid: 'fas',
        light: 'fal',
        duotone: 'fad'
    }[type] ?? 'fal'

    let fontSize, iconSize
    if (typeof size === 'number') fontSize = size
    if (typeof size === 'string') iconSize = size

    const styleObj = {
        fontStyle: 'normal',
        lineHeight: 1,
        ...(color && { color: `var(--bs-${color})` }),
        ...style
    }

    return (
        <span
            className={classes}
            style={styleObj}
            {...otherProps}>
            <FontAwesomeIcon
                ref={ref}
                icon={[iconType, `${name}`]}
                pull={pull}
                border={border}
                inverse={inverse}
                fixedWidth={fixedWidth}
                {...iconSize && {size: iconSize}}
                {...fontSize && {style: {fontSize}}}
                {...faProps}
            />
        </span>
    )
})

export { Icon }
